import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';


export default function UploadIllusionEDLPullModSummary(props) {
    const { editedPlates, edlSummary, getDuplicatePlates, selectionModel } = props;

    const [totalFrameCount, setTotalFrameCount] = useState(0);
    const [totalPlateCount, setTotalPlateCount] = useState(0);
    const [selectedFrameCount, setSelectedFrameCount] = useState(0);
    const [selectedPlateCount, setSelectedPlateCount] = useState(0);
    const [duplicatedCount, setDuplicatedCount] = useState(0);

    useEffect(() => {
        setTotalFrameCount(
            (edlSummary?.plates ?? []).reduce((frameCount, plate) => {
                return frameCount
                + ((plate?.handle ?? 0) * 2)
                + Math.abs(
                    (plate?.source?.at(0) ?? 0)
                    - (plate?.source?.at(1) ?? 0)
                );
            }, 0)
        );
        setTotalPlateCount(edlSummary?.plates?.length ?? 0);
    }, [edlSummary]);

    useEffect(() => {
        setSelectedFrameCount(
            (editedPlates.filter(plate => selectionModel.includes(plate.id)) ?? []).reduce((frameCount, plate) => {
                return frameCount
                    + ((plate?.handle ?? 0) * 2)
                    + Math.abs(
                        (plate?.cut?.at(0) ?? 0)
                        - (plate?.cut?.at(1) ?? 0)
                    );
            }, 0)
        );
        setSelectedPlateCount(selectionModel?.length ?? 0);
        setDuplicatedCount(editedPlates?.filter(plate => getDuplicatePlates(editedPlates).map(dup => dup.id).includes(plate.id)).length ?? 0)
    }, [selectionModel, editedPlates]);


    return (
        <Box
            id="pull-mod-summary"
            sx={{
                backgroundColor: '#141414',
                borderRadius: '8px',
                height: 'auto',
                mb: 1,
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                color: 'white',
                position: 'relative'
            }}
        >
            <Typography variant="h6" sx={{ mb: 2 }}>
                {`Pull Modification Summary`}
            </Typography>
            <Box display="flex" sx={{ width: '100%', justifyContent: 'space-between' }}>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <Typography sx={{ fontSize: 14, fontWeight: 'medium' }}>Available Plates: {totalPlateCount}</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 'medium' }}>Available Frames: {totalFrameCount}</Typography>
            </Box>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <Typography sx={{ fontSize: 14, fontWeight: 'medium', color: duplicatedCount > 0 ? 'red' : 'white' }}>Duplicate Plates: {duplicatedCount}</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 'medium', color: (edlSummary?.missing_plates ?? [])?.length ?? 0 > 0 ? 'red' : 'white' }}>Missing Shots: {(edlSummary?.missing_plates ?? [])?.length ?? 0}</Typography>
            </Box>
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <Typography sx={{ fontSize: 14, fontWeight: 'medium' }}>Selected Plates: {selectedPlateCount}</Typography>
                <Typography sx={{ fontSize: 14, fontWeight: 'medium' }}>Selected Frames: {selectedFrameCount}</Typography>
            </Box>
            </Box>
        </Box>
    );
}